module.exports = __webpack_public_path__ + "56687648a7fa8dbe9b6d78318cba1d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/thumbnails/field-trip.png
// module id = 916
// module chunks = 4